
const IMAGES = {
   stars:require('./images/back/background.png'),
   filter:require('./images/filter/Filter.png'),
   sofmenHeader:require('./images/headerLogo/header.png'),
   backSofmenImg:require('./images/backHeaderImg/backImg.png'),
   pmo:require('./images/PMO.jpeg')
}

export default IMAGES